import Vue from 'vue'
/**权限指令**/
const role = Vue.directive('role', {
  bind: function (el, binding, vnode) {
    // 获取按钮权限
    if(binding.value){
      console.log(binding.value)
      const level =  parseInt(binding.value.level)|| 0
      const isShow = parseInt(binding.value.regionLevel5Switch)|| 0
      if(level === 5 && isShow ===2){
        el.parentNode.removeChild(el);
      }
    }
  }
});
export default  role



// WEBPACK FOOTER //
// ./src/directive/role/index.js